import React from 'react';

const GraphAlgorithms = () => {
  const algorithms = [
    { name: 'Depth First Search (DFS)', description: 'Explore graph depth-wise', path: '/dfs', gradient: 'linear-gradient(135deg, #ff6b6b, #ee5a24)', shadow: 'rgba(255, 107, 107, 0.4)' },
    { name: 'Breadth First Search (BFS)', description: 'Explore graph level by level', path: '/bfs', gradient: 'linear-gradient(135deg, #ff9f43, #ff6348)', shadow: 'rgba(255, 159, 67, 0.4)' },
    { name: 'Dijkstra\'s Algorithm', description: 'Find shortest paths', path: '/dijkstra', gradient: 'linear-gradient(135deg, #feca57, #ff9ff3)', shadow: 'rgba(254, 202, 87, 0.4)' },
    { name: 'Kruskal\'s Algorithm', description: 'Minimum spanning tree', path: '/kruskal', gradient: 'linear-gradient(135deg, #48dbfb, #0abde3)', shadow: 'rgba(72, 219, 251, 0.4)' },
    { name: 'Prim\'s Algorithm', description: 'Greedy MST construction', path: '/prims', gradient: 'linear-gradient(135deg, #4834d4, #686de0)', shadow: 'rgba(72, 52, 212, 0.4)' },
    { name: 'Bellman-Ford Algorithm', description: 'Detect negative cycles', path: '/bellmanford', gradient: 'linear-gradient(135deg, #00d2d3, #54a0ff)', shadow: 'rgba(0, 210, 211, 0.4)' },
    { name: 'Floyd-Warshall Algorithm', description: 'All pairs shortest paths', path: '/floydwarshall', gradient: 'linear-gradient(135deg, #ff9ff3, #f368e0)', shadow: 'rgba(255, 159, 243, 0.4)' },
    { name: 'Topological Sort', description: 'Order vertices linearly', path: '/topologicalsort', gradient: 'linear-gradient(135deg, #a55eea, #8854d0)', shadow: 'rgba(165, 94, 234, 0.4)' },
    { name: 'Kahn\'s Algorithm', description: 'Topological sort using BFS', path: '/kahns', gradient: 'linear-gradient(135deg, #26de81, #20bf6b)', shadow: 'rgba(38, 222, 129, 0.4)' },
    { name: 'Kosaraju\'s Algorithm', description: 'Find strongly connected components', path: '/kosaraju', gradient: 'linear-gradient(135deg, #fd79a8, #e84393)', shadow: 'rgba(253, 121, 168, 0.4)' }
  ];

  return (
    <div style={{
      backgroundColor: '#0a0e1a',
      backgroundImage: 'linear-gradient(rgba(10, 14, 26, 0.7), rgba(10, 14, 26, 0.7)), url(https://xomnia.com/wp-content/uploads/2025/05/Graph-theory-and-its-uses-with-5-examples-of-real-life-problems.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      color: 'white',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      margin: 0,
      padding: 0,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <a href="/visualizer" style={{
        position: 'absolute',
        top: '40px',
        left: '40px',
        background: 'linear-gradient(135deg, #7c3aed, #3b82f6)',
        color: 'white',
        padding: '14px 24px',
        border: 'none',
        borderRadius: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        textDecoration: 'none',
        boxShadow: '0 8px 25px rgba(124, 58, 237, 0.4)',
        backdropFilter: 'blur(10px)',
        transition: 'all 0.3s ease',
        fontSize: '0.95rem'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'translateY(-2px)';
        e.target.style.boxShadow = '0 12px 35px rgba(124, 58, 237, 0.5)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translateY(0)';
        e.target.style.boxShadow = '0 8px 25px rgba(124, 58, 237, 0.4)';
      }}>
        ← Back to Dashboard
      </a>
      
      <div style={{
        textAlign: 'center',
        marginTop: '120px',
        marginBottom: '60px'
      }}>
        <h1 style={{
          fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
          fontWeight: '800',
          color: 'white',
          letterSpacing: '-0.02em',
          marginBottom: '1rem',
          textShadow: '0 4px 8px rgba(0,0,0,0.3)'
        }}>
          Graph Algorithms
        </h1>
        <p style={{
          fontSize: '1.2rem',
          color: '#94a3b8',
          fontWeight: '400',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          Explore graph traversal and shortest path algorithms
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '30px',
        maxWidth: '1000px',
        padding: '0 40px 80px',
        width: '100%'
      }}>
        {algorithms.map((algorithm, index) => (
          <div
            key={index}
            style={{
              background: algorithm.gradient,
              borderRadius: '20px',
              padding: '35px 25px',
              textAlign: 'center',
              transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
              boxShadow: `0 4px 15px ${algorithm.shadow.replace('0.4', '0.2')}`,
              transform: 'translateY(0) scale(1)',
              border: 'none',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px) scale(1.01)';
              e.target.style.boxShadow = `0 8px 20px ${algorithm.shadow.replace('0.4', '0.3')}`;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0) scale(1)';
              e.target.style.boxShadow = `0 4px 15px ${algorithm.shadow.replace('0.4', '0.2')}`;
            }}
          >

            <h3 style={{ 
              margin: '0 0 15px', 
              fontSize: '1.6rem', 
              fontWeight: '800',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}>
              {algorithm.name}
            </h3>
            
            <p style={{ 
              fontSize: '1rem', 
              opacity: 0.95, 
              margin: '0 0 20px',
              fontWeight: '500',
              textShadow: '0 1px 2px rgba(0,0,0,0.1)',
              color: 'black'
            }}>
              {algorithm.description}
            </p>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              alignItems: 'center'
            }}>
              <button 
                onClick={(e) => { 
                  e.stopPropagation(); 
                  const name = algorithm.name.toLowerCase().replace(/\s+/g, '').replace(/'/g, '').replace(/-/g, '').replace(/\([^)]*\)/g, '');
                  if (name === 'dijkstrasalgorithm') window.location.href = '/dijkstra';
                  else if (name === 'kruskalsalgorithm') window.location.href = '/kruskal';
                  else if (name === 'primsalgorithm') window.location.href = '/prims';
                  else window.location.href = `/${name}visualize`;
                }}
                style={{
                background: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)',
                border: 'none',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '25px',
                fontWeight: '700',
                fontSize: '12px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                width: '120px',
                boxShadow: '0 10px 20px rgba(6, 182, 212, 0.2)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.08)';
                e.target.style.boxShadow = '0 20px 40px rgba(6, 182, 212, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 10px 20px rgba(6, 182, 212, 0.2)';
              }}>
                Visualize
              </button>
              
              <button 
                onClick={(e) => { 
                  e.stopPropagation(); 
                  const name = algorithm.name.toLowerCase().replace(/\s+/g, '').replace(/'/g, '').replace(/-/g, '').replace(/\([^)]*\)/g, '');
                  window.location.href = `/${name}code`; 
                }}
                style={{
                background: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)',
                border: 'none',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '25px',
                fontWeight: '700',
                fontSize: '12px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                width: '120px',
                boxShadow: '0 10px 20px rgba(139, 92, 246, 0.2)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.08)';
                e.target.style.boxShadow = '0 20px 40px rgba(139, 92, 246, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 10px 20px rgba(139, 92, 246, 0.2)';
              }}>
                Code
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GraphAlgorithms;